import { Status } from '../Components/Status';

export function TelegramConnectionStatus({ connected }: { connected: boolean }) {
    return (
        <div className='flex items-center text-[14px]'>
            <Status className='mr-[7px]' status={connected ? 'ok' : 'notOk'} statusMap={Status.defaultStatusMap} />
            Telegram {connected ? 'Connected' : 'Not Connected'}
        </div>
    );
}
